export default __webpack_public_path__ + "static/media/solarp1.a303d4ef.jpg";